// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3R3xX","options":"AnswerScale_options__1w7sb","selected":"AnswerScale_selected__2viaP"};